import PropTypes from "prop-types"
import styled from "styled-components"
import { whiteTheme, borderTheme, brandSecondaryColor } from "../../../theme"

const NavBarBackground = styled.div`
  display: flex;
  background-color: ${whiteTheme};
  border-bottom: 1px solid ${borderTheme};
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: saturate(180%) blur(20px);
  align-items: center;
  /* position: relative; */
  position: fixed;
  width: 100%;
  z-index: 1000;
  transition: all 300ms linear;

  &.stickyNav {
    transition: all 300 linear;
    background-color: ${brandSecondaryColor};
  }

  ${({ theme }) => theme.desktop`
    
  `}
`
NavBarBackground.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default NavBarBackground
